import { ITypographyHeadingVariants } from 'components/typography';

export const iterateHeading = (heading?: ITypographyHeadingVariants): ITypographyHeadingVariants | undefined => {
	if (!heading || !heading.match(/h\d/g)) return heading;
	const headingNumber = Number(heading.substring(heading.length - 1));
	return `h${headingNumber + 1}` as ITypographyHeadingVariants;
};
